import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled.div`
    max-width: ${grid.multiple(70).px};
    padding: ${token('space.400', '32px')} ${token('space.100', '8px')} ${token('space.100', '8px')}
        ${token('space.100', '8px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Title = styled.div`
    text-align: center;
    font-weight: bold;
    padding: ${token('space.200', '16px')} 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const HelperText = styled.div`
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Img = styled.img`
    width: ${grid.multiple(13).px};
    height: ${grid.multiple(10).px};
    margin: 0 auto;
    display: block;
    padding: ${token('space.200', '16px')};
`;
